import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { PictureFillIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
export const HintImageUploadButton = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(({
  onClick,
  ...props
}, ref) => {
  const {
    t
  } = useTranslation(['build']);
  return <div ref={ref} {...props} className={cn('flex cursor-pointer flex-col items-center justify-center', props.className)} onMouseDown={e => {
    e.stopPropagation();
    e.preventDefault();
  }} onClick={e => {
    e.stopPropagation();
    e.preventDefault();
    onClick?.(e);
  }}>
      <PictureFillIcon size="xl" fill={ICON_COLOR.disabled} />
      <span className="text-center text-caption-md-semibold leading-normal text-gray-500">
        {t('build.imageUpload.placeHolder')}
      </span>
    </div>;
});